import React from "react";
import "./Button.scss";
import ButtonProps from "./Button.types";
import SVG from "../SVG/SVG";

const Button = ({
  children,
  className = "",
  category = "primary",
  size = "medium",
  isRounded = false,
  isIcon = false,
  icon = "delete",
  ...props
}: any) => {
  const commonButtonProp = {
    ...props,
    className: `button button--${category} button--${size}${
      isRounded ? " button--rounded" : ""
    } ${isIcon ? "icon_button" : ""} ${className}`,
  };
  return (
    <button {...commonButtonProp}>
      {isIcon ? <SVG type={icon} /> : ""}
      {children}
    </button>
  );
};

export default Button;
